import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { BrandingStore } from 'src/core/stores/branding.store';

// Revisa el TTL del branding en cada route change (sin WS/SSE/polling).
@Injectable({ providedIn: 'root' })
export class BrandingRefreshService {
  private readonly router = inject(Router);
  private readonly branding = inject(BrandingStore);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => this.branding.refreshIfStale());
  }
}
